// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"39796eb1","787":"7c129d98"}[chunkId] + ".chunk.css";
};